import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = { modalType: String };
  static targets = ['title'];

  connect() {
    if (this.modalTypeValue === 'offcanvas') {
      this.modal = new bootstrap.Offcanvas(this.element, {
        backdrop: 'static'
      });
      return;
    }

    this.modal = new bootstrap.Modal(this.element, {
      backdrop: 'static'
    });
  }

  open(event) {
     console.debug("MODAL FORM: Frame load (open)", event);

    if (!this.modal.isOpened) {
      this.modal.show();
    }

  }

  hide() {
    this.modal.hide();
  }

  beforeRender(event) {
     console.debug("MODAL FORM: Before Render", event);
    // The title comes from the new gotten Frame
    const title = event.detail.newFrame.dataset.title || "";
    this.titleTarget.innerHTML = title;
  }

  close(event) {
     console.debug("MODAL FORM: Submit end", event);

    if (event.detail.success) {
      this.modal.hide();
    }
  }
}
